import { action, observable } from 'mobx';
import { RootStore } from 'stores/rootStore';
import { ApiStore } from 'stores/apiStore';
import { SingleValueResponse } from 'common/interfaces';
import { AccountDetailStore } from './accountDetailStore';
import { Flows, flows } from 'pages/Accounts/Detail/enums';
import { API_ACCOUNT_DETAIL_CHANGE, API_ACCOUNT_DETAIL_COMPLETE } from 'api/endpoints';

export interface DocumentData {
  type: string;
  date: string;
  key: string;
  loading?: boolean;
}

export class DocumentsStore {
  rootStore: RootStore;
  flow: Flows;
  accountId: string;
  apiStore: ApiStore;
  @observable data: DocumentData[] | null;
  typesParam: string;

  constructor(rootStore: RootStore, flow: Flows, accountId: string) {
    this.rootStore = rootStore;
    this.flow = flow;
    this.accountId = accountId;
    this.apiStore = rootStore.stores.apiStore;
    this.data = null;
    this.typesParam = '';
  }

  @action fetchData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.apiStore.get<DocumentData[]>(
      API_ACCOUNT_DETAIL_CHANGE(this.accountId),
    );
    this.rootStore.stores.uiStore.setLoading(false);
    if (response?.data) {
      this.data = response.data.map((doc: DocumentData) => {
        doc.loading = false;
        return doc;
      });
      this.typesParam = response.data.map((doc: DocumentData) => doc.type).join(',');
    }
  };

  @action downloadDocument = async (document: DocumentData) => {
    this.setLoadingForDocument(document, true);
    await this.apiStore.get(
      `/account/${this.accountId}/pdf/${        
        //[Flows.PLAN, Flows.PRICELIST, Flows.PERSONAL].includes(this.flow)
        flows[this.flow].changeFlow
          ? 'change/'
          : ''
      }${document.type}`,
    );
    this.setLoadingForDocument(document, false);
  };

  @action
  setLoadingForDocument = (document: DocumentData, loading: boolean) => {
    this.data = this.data!.map((doc) => {
      if (doc.type === document.type) {
        doc.loading = loading;
      }
      return doc;
    });
  };

  @action
  sendDocuments = async (accountDetailStore: AccountDetailStore) => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.apiStore.patch<SingleValueResponse<boolean>>(
      API_ACCOUNT_DETAIL_COMPLETE(this.accountId, flows[this.flow].beFlow || this.flow, this.typesParam),
    );

    if (response?.data?.value === true) {
      accountDetailStore.startProcessing(this.typesParam);
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };
}
